// react
import { useCallback, useEffect, useMemo } from 'react';

// hooks
import {
  useCreateChatMutation,
  useGetChatQuery,
  useSendChatMessageMutation,
  useGetAllChatQuery,
} from 'store/api/chat';

// models
import { ChatType } from '@karehero/models';

interface UseChatOptions {
  chatID?: string;
}

// INFO: commented code is reference for how sentMessages that haven't yet been fulfilled as part of a post request were stored; prior to the polling patch
export const useChat = (options?: UseChatOptions) => {
  // state
  //const [isChatLoading, setIsChatLoading] = useState(false);
  //const [sentMessages, setSentMessages] = useState<ChatMessage[]>([]);

  // hooks
  const {
    data: chat,
    refetch: refetchChat,
    error: chatError,
  } = useGetChatQuery(options?.chatID || '', {
    skip: !options?.chatID,
  });
  const { data: chats, refetch: refetchChats } = useGetAllChatQuery();
  const [createChat] = useCreateChatMutation();
  const [sendChatMessage] = useSendChatMessageMutation();

  // methods
  const sendMessage = useCallback(
    async (message: string) => {
      if (!message) return;

      //const randomID = Math.random().toString(36);
      // setSentMessages((prev) => [
      //   ...prev,
      //   {
      //     id: randomID,
      //     role: 'user',
      //     content: message,
      //   },
      // ]);
      //
      if (!chat?.id) return;
      await sendChatMessage({ chatID: chat.id, content: message });
      await refetchChat();
      //setSentMessages((prev) => prev.filter((m) => m.id !== randomID));
    },
    [chat, sendChatMessage, refetchChat],
  );

  // memos
  const messages = useMemo(() => chat?.messages || [], [chat]);

  //   return [...(chat?.messages || []), ...sentMessages];
  // }, [chat, sentMessages]);
  //
  const isChatLoading = useMemo(() => {
    if (chat?.chatType !== ChatType.ChatTypeAgent) {
      return false;
    }

    return messages[messages.length - 1]?.role === 'user';
  }, [chat, messages]);

  // effects
  useEffect(() => {
    if (chatError && 'status' in chatError && chatError.status === 404) {
      createChat({ chatType: ChatType.ChatTypeAgent });
    }
  }, [createChat, chatError]);

  // TODO: remove once websockets are implemented
  useEffect(() => {
    const intervalId = setInterval(() => chat?.id && refetchChat(), 2000);
    return () => clearInterval(intervalId);
  }, [chat, refetchChat]);

  return {
    chat,
    messages,
    isChatLoading,
    sendMessage,
    createChat,
    chats,
    refetchChats,
  };
};
